import { Pipe, PipeTransform } from '@angular/core';
import { TranslationTag } from '@shared/models/components/event-information-component';
import { getLocaleFormattedDate } from '@shared/utils/helper.util';

@Pipe({
  name: 'translationTags',
})
export class TranslationTagsPipe implements PipeTransform {
  transform(
    translatedString: string,
    translationTags: TranslationTag[],
    language?: string,
  ) {
    if (translationTags) {
      for (const tag of translationTags) {
        if (typeof tag.key === 'string' && typeof tag.value === 'string') {
          let formattedValue = tag.value;
          if (language && tag.formatType === 'DATETIME') {
            formattedValue = getLocaleFormattedDate(tag.value, language);
          }
          translatedString = translatedString.replace(
            new RegExp(tag.key, 'g'),
            formattedValue,
          );
        }
      }
    }
    return translatedString;
  }
}
